import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'src/app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'src/app/core/core.module';
import { EmployeeSearchComponent } from './employee-search/employee-search.component';
import { EmployeeDetailComponent } from './employee-detail/employee-detail.component';
import { UsersOverviewComponent } from './users-overview/users-overview.component';
import { UserDetailDialogComponent } from './user-detail-dialog/user-detail-dialog.component';
import { TableEditComponent } from './table-edit/table-edit.component';
import { TimeCategoryDialogComponent } from './time-category-dialog/time-category-dialog.component';
import { JobTypeDialogComponent } from './job-type-dialog/job-type-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'admin',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'employees', component: EmployeeSearchComponent, data: { title: 'Employee' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'employees/:id', component: EmployeeDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'users', component: UsersOverviewComponent, data: { title: 'Users' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'lookup-tables', component: TableEditComponent, data: { title: 'Lookup Tables' }, canActivate: [AuthGuard, PrepareGuard] }
                ]
            }
        ])
    ],
    declarations: [
        EmployeeSearchComponent,
        EmployeeDetailComponent,
        UsersOverviewComponent,
        UserDetailDialogComponent,
        TableEditComponent,
        TimeCategoryDialogComponent,
        JobTypeDialogComponent
    ]
})
export class AdminModule {}
